module.exports = __webpack_public_path__ + "img/made_6.02942263.png";